import {Component} from '@angular/core';
import { navItems } from '../../_nav';
import { AuthenticationService } from '../../_services/auth/authentication-service.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent {
  public sidebarMinimized = false;
  public navItems = navItems;
  constructor(private authService : AuthenticationService){

  }
  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
  logOut(){
    this.authService.logout();
  }
}
